export default "__VITE_ASSET__ZEjjUWKy__"